import { render, staticRenderFns } from "./CollectionCreate.vue?vue&type=template&id=3abb6bd4&scoped=true"
import script from "./CollectionCreate.vue?vue&type=script&lang=js"
export * from "./CollectionCreate.vue?vue&type=script&lang=js"
import style0 from "./CollectionCreate.vue?vue&type=style&index=0&id=3abb6bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb6bd4",
  null
  
)

export default component.exports